import React, { useEffect, useRef, useState } from 'react'
import Tooltip from '@components/tooltip'
import IconSearch from '@kawaui/icons/build/icons/informative/Search'
import useLocalStorage from '@rehooks/local-storage'
import connect from './connector'
import { Wrapper } from './style'
import { Props } from './types'

const MAX_DISPLAY_COUNT = 3
const SEARCH_BUTTON_TOOLTIP_LC_KEY = 'travel-tsf-search-button'
const DISPLAY_TIME = 5000

const SearchButton: React.FC<Props> = ({ disabled, onRedirectToNavigation, onSearchButtonClick, p, visible }) => {
  const [tooltipDisplayCount, setTooltipDisplayCount] = useLocalStorage<number>(SEARCH_BUTTON_TOOLTIP_LC_KEY, MAX_DISPLAY_COUNT)
  const isTooltipEnabled = visible && !disabled && tooltipDisplayCount > 0
  const [isTooltipDisplayed, setIsTooltipDisplayed] = useState<boolean>(false)
  const idRef = useRef<ReturnType<typeof setTimeout>>()

  const clearTooltipTimeout: VoidFunction = () => clearTimeout(idRef.current as ReturnType<typeof setTimeout>)
  const decrementDisplayCount: VoidFunction = () => setTooltipDisplayCount(tooltipDisplayCount - 1)
  const handleClick: VoidFunction = () => {
    if (isTooltipEnabled) decrementDisplayCount()
    onSearchButtonClick()
    onRedirectToNavigation()
  }

  useEffect(() => {
    if (isTooltipEnabled) {
      setIsTooltipDisplayed(true)
      const tooltipTimeout = setTimeout(() => {
        decrementDisplayCount()
        setIsTooltipDisplayed(false)
      }, DISPLAY_TIME)
      idRef.current = tooltipTimeout
    } else {
      clearTooltipTimeout()
    }
    return () => {
      clearTooltipTimeout()
    }
  }, [isTooltipEnabled])

  if (disabled) return null

  return (
    <Tooltip
      containerStyle={{ width: '184px' }}
      content={p.tc('catalog.navigation.search_button.tooltip')}
      isOpen={isTooltipDisplayed && isTooltipEnabled}
      placement='top-end'
      variant='primary'
    >
      <Wrapper onClick={handleClick}>
        <IconSearch height='24px' width='24px' />
      </Wrapper>
    </Tooltip>
  )
}

export default connect(SearchButton)
